/* The newsletter forms' element (snippets/cf-newsletter-form), moved out of the snippet on 2026-10-25: the snippet is drawn
   two or three times a page, and printed this script each time. */
(() => {
  if (customElements.get('cf-newsletter-form')) return;
  /* Klaviyo's public site ID, meant for browsers; the list comes with each form (data-list). */
  const COMPANY = 'Tryy7A';

  /* Who is already on the list, as far as this browser can tell, kept as cf_nl so the newsletter tile
     (cf-newsletter-tile) stays out of their way: anyone who signs up here, and - with marketing consent only, once
     the page has loaded the consent API - anyone who came in from one of our emails (Klaviyo's links carry _kx). */
  const remember = () => { try { localStorage.setItem('cf_nl', '1'); } catch (e) {} };
  window.addEventListener('cf:newsletter-signup', remember);
  if (new URLSearchParams(location.search).has('_kx')) {
    window.addEventListener('load', () => { if (window.Shopify?.customerPrivacy?.marketingAllowed?.()) remember(); });
  }

  const subscribe = async ({ email, firstName = '', source, list = 'XV6SUr', main = true }) => {
    const attributes = { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }, properties: main ? { MainNewsletter: 'true' } : {} };
    if (firstName) attributes.first_name = firstName;
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${COMPANY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: { custom_source: source, profile: { data: { type: 'profile', attributes } } },
        relationships: { list: { data: { type: 'list', id: list } } },
      } }),
    });
    if (!response.ok) throw new Error(`Klaviyo answered ${response.status}`);
    window.dispatchEvent(new CustomEvent('cf:newsletter-signup', { detail: { email, source } }));
  };
  window.cfNewsletterSubscribe = subscribe;

  customElements.define('cf-newsletter-form', class extends HTMLElement {
    /* The submit is caught on the element, not the form: a form parsed after this script (every one but the
       page's first) is connected before its <form> exists, and used to reload the page instead of sending. */
    connectedCallback() {
      if (this.wired) return;
      this.wired = true;
      this.addEventListener('submit', (event) => { event.preventDefault(); this.send(event.target); });
    }

    async send(form) {
      if (this.busy) return;
      const data = new FormData(form);
      if (data.get('website')) { this.finish(); return; }
      const email = String(data.get('email') || '').trim();
      const firstName = String(data.get('first_name') || '').trim();
      const error = this.querySelector('[data-error]'), button = form.querySelector('[type="submit"]');
      this.busy = true; error.hidden = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
      try {
        await subscribe({ email, firstName, source: this.dataset.source, list: this.dataset.list, main: this.dataset.main !== '0' });
        this.finish();
      } catch (e) {
        error.hidden = false;
      } finally {
        this.busy = false; button.disabled = false; button.removeAttribute('aria-busy');
      }
    }

    finish() {
      this.querySelector('form').hidden = true;
      this.querySelector('[data-done]').hidden = false;
    }
  });
})();
